import { createStore } from 'vuex';
import auth from './modules/auth';
import rma from './modules/rma';
import upload from './modules/upload';
import policy from './modules/policy';
import platform from './modules/platform';
import credential from './modules/credential';
import policyEngine from './modules/policyEngine';
export default createStore({
    modules: {
        auth,
        rma,
        upload,
        policy,
        platform,
        credential,
        policyEngine,
    },
});
